import { createSelector } from 'reselect'
import { User } from 'types/User'
import { Cart } from 'types/User/Cart'
import { getUser } from './helpers'

export const getCart = createSelector([getUser], (user: User): Cart => user.cart || {})

export const getCartCount = createSelector([getCart], (cart: Cart): number => cart.count || 0)
